import Faqs from "../../../components/landingSections/faqs/Faqs";
import Footer from "../../../components/landingSections/footer/Footer";
import Header from "../../../components/landingSections/header/Header";
import WhyFalBio from "../../../components/landingSections/whyFalbio/WhyFalBio";
import NewBanner from "../../../components/newLandingSections/NewBanner";
import { Box } from "../../../components/styled/Elements";

import {
  faqSecData,
  howItWorksData,
  whyFalSecData,
} from "../../../components/data/data";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Contact from "../../../components/landingSections/contact/Contact";
import HowItWorksNew from "../../../components/landingSections/howItWorks/HowItWorksNew";

const NewLandingPage = () => {
  const location = useLocation();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const scrollTo = params.get("scrollTo");
    if (scrollTo) {
      setTimeout(() => {
        const el = document.getElementById(scrollTo);
        if (el) {
          el.scrollIntoView({ behavior: "smooth" });
        }
      }, 100);
    }
  }, [location]);
  return (
    <Box bg="var(--white)" className="overflow-x-hidden">
      <Header btnLabel="get_searched_with_us" btnUrl="/professionals" />
      <NewBanner />
      <WhyFalBio data={whyFalSecData} />
      <HowItWorksNew title="how_to_find_trusted_agent" data={howItWorksData} />
      <Faqs data={faqSecData} />
      <Contact />
      <Footer />
    </Box>
  );
};

export default NewLandingPage;
